import { combineReducers } from 'redux';
import { authentication } from './authentication/authentication';
import { captcha } from './captcha/captcha';
import { pagination } from './pagination/pagination';
import {
  apiReadOnlyFields,
  attemptedInvalidSMSNumber,
  autoLoadOnlineScript,
  cardElementFlowEnabled,
  couponAdded,
  createPaymentFailure,
  currentStepIndex,
  displayCoupon,
  displayPayerInformation,
  docCollectorFinished,
  duplicatedPayment,
  embedded,
  fieldValues,
  gatewayOrigin,
  gatewaySource,
  hideCancelPaymentOption,
  hideUserManagement,
  isChatVisible,
  isDocumentsFetchFailure,
  isImpersonatingUser,
  isLanguageSelectorViewVisible,
  isPaymentProcess,
  isRepeatingPayment,
  isTrackingPage,
  lastPaymentFromSameRecipient,
  locale,
  maxAmount,
  notifications,
  payerInformationCountrySuggestion,
  payerInformationFields,
  prefilledFields,
  prefilledRejectOrConfirm,
  readOnlyFields,
  receiveSMSNotification,
  recurringConfigurationId,
  redirectToReferrer,
  refundKYCProcessCompleted,
  showOfflineInstructions,
  taxServiceUnavailable,
  theme,
  userExists,
  validRefundKYCToken,
} from './ui';

export const ui = combineReducers({
  apiReadOnlyFields,
  attemptedInvalidSMSNumber,
  authentication,
  autoLoadOnlineScript,
  cardElementFlowEnabled,
  createPaymentFailure,
  currentStepIndex,
  docCollectorFinished,
  duplicatedPayment,
  embedded,
  fieldValues,
  gatewayOrigin,
  gatewaySource,
  hideCancelPaymentOption,
  hideUserManagement,
  isChatVisible,
  isDocumentsFetchFailure,
  isImpersonatingUser,
  isLanguageSelectorViewVisible,
  isPaymentProcess,
  isRepeatingPayment,
  isTrackingPage,
  lastPaymentFromSameRecipient,
  locale,
  maxAmount,
  notifications,
  pagination,
  prefilledFields,
  prefilledRejectOrConfirm,
  readOnlyFields,
  receiveSMSNotification,
  redirectToReferrer,
  refundKYCProcessCompleted,
  showOfflineInstructions,
  taxServiceUnavailable,
  theme,
  userExists,
  validRefundKYCToken,
  captcha,
  payerInformationFields,
  displayPayerInformation,
  recurringConfigurationId,
  displayCoupon,
  couponAdded,
  payerInformationCountrySuggestion,
});
